import { jsxs, jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Header } from "@perxis-auto/ui-kit/lib/components/Header";
import clsx from "clsx";
import styles from "./VehiclesCatalogHeader.module.scss.js";
const VehiclesCatalogHeader = memo(function VehiclesCatalogHeader2({
  sortValue,
  items,
  isSortEnabled,
  onSortChange,
  vehiclesCount,
  t,
  className,
  ...props
}) {
  const isHiddenSort = !isSortEnabled || !items.length;
  return /* @__PURE__ */ jsxs(
    Row,
    {
      align: "middle",
      justify: "space-between",
      wrap: false,
      className: clsx(styles.vehiclesCatalogHeader, className),
      ...props,
      children: [
        /* @__PURE__ */ jsx(Col, { flex: "auto", children: /* @__PURE__ */ jsx(
          Header.Counter,
          {
            count: vehiclesCount,
            prefix: t("widgets.vehiclesCatalogHeader.counter.find", {
              count: vehiclesCount
            }),
            postfix: t("widgets.vehiclesCatalogHeader.counter.auto", {
              count: vehiclesCount
            })
          }
        ) }),
        !isHiddenSort && /* @__PURE__ */ jsx(Col, { flex: "none", children: /* @__PURE__ */ jsx(
          Header.Sort,
          {
            title: t("widgets.vehiclesCatalogHeader.sort.title"),
            value: JSON.stringify(sortValue),
            items,
            onSelect: onSortChange
          }
        ) })
      ]
    }
  );
});
export {
  VehiclesCatalogHeader
};
